import { defineComponent, h } from 'vue';
import { ItemProps } from '@/ui/components/inspectionReport/types';
import { useInspectionReport } from '@/ui/components/inspectionReport/useInspectioReport';
import { LegacyItem } from '@/ui/components/inspectionReport/legacyTypes';
import QuestionFactory from '@/ui/components/inspectionReport/factories/QuestionFactory';

interface QuestionProps extends ItemProps {
  withIssues: boolean;
  questionFactory: QuestionFactory;
}

const Question = defineComponent<QuestionProps>({
  name: 'Question',
  props: ['item', 'withIssues', 'questionFactory'],
  setup(props) {
    return function render() {
      return props.questionFactory.getQuestion(props.item, { withIssues: props.withIssues });
    };
  },
});

export function makeQuestion(item: LegacyItem, withIssues = true) {
  return h(Question, {
    props: {
      item,
      withIssues,
      questionFactory: useInspectionReport().getInspectionQuestionFactory(),
    },
  });
}
